import { Box, Typography } from '@mui/material';

type TitledNotificationBodyProps = {
  title: string;
  text: string;
};

/**
 * The title and text of a titled toast: title 16/600, text 14/400 (Figma `Product` node 1878:584).
 * `enqueTitledNotification` hands it to notistack as the toast's message, so the toast's content
 * component only has to add the icon, the fill and the close button around it.
 */
export const TitledNotificationBody = ({ title, text }: Readonly<TitledNotificationBodyProps>) => (
  <Box
    sx={(theme) => ({
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.semantic.spacing['2xs'],
    })}
  >
    <Typography variant="h6" component="p" color="inherit">
      {title}
    </Typography>
    <Typography variant="body2" component="p" color="inherit">
      {text}
    </Typography>
  </Box>
);
